import type { ProductSearchFilterCategory } from '@jane/bloom/viewModels/productSearchFilters';

// sort alphabetically
export const getDefaultSortedCategories = ({
  categories,
}: {
  categories: ProductSearchFilterCategory[];
}) =>
  categories.sort((a, b) => {
    return a.label.localeCompare(b.label);
  });
